module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h3bNV"))).then(() => parcelRequire('d0iPb'));